import React from 'react';
import { useParams } from 'react-router-dom';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Divider,
  Chip,
  Container
} from '@mui/material';

export default function Verify() {
  const { brandname, batchno } = useParams();
  
  // Decode the URL parameters
  const decodedBrandName = decodeURIComponent(brandname);
  const decodedBatchNo = decodeURIComponent(batchno);

  // Check if the verification is for valid products
  const isValidProduct = (
    (decodedBrandName === 'AQkuff-DX') ||
    (decodedBrandName === 'AQkuff-AM')
  );

  if (!isValidProduct) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h5">Invalid Product Verification</Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          The product verification details could not be found.
        </Typography>
      </Box>
    );
  }

  const getProductDetails = () => {
    if (decodedBrandName === 'AQkuff-DX') {
      return {
        genericName: 'Dextromethorphan Hydrochloride, Phenylephrine Hydrochloride & Chlorpheniramine malate',
        brandName: 'AQkuff-DX',
        batchNumber: 'BL24062',
        mfgDate: '07/2024',
        expiryDate: '06/2026',
        licenseNumber: 'G/25/2621',
        image: "AQkuff-DX.png"
      };
    } else if (decodedBrandName === 'AQkuff-AM') {
      return {
        genericName: 'Ambroxol Hydrochloride, Terbutaline Sulphate & Guaiphenesin',
        brandName: 'AQkuff-AM',
        batchNumber: 'BL24063',
        mfgDate: '07/2024',
        expiryDate: '06/2026',
        licenseNumber: 'G/25/2621',
        image: "AQkuff-AM.png"
      };
    }
  };

  const productDetails = getProductDetails();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper 
        elevation={0} 
        sx={{ 
          p: { xs: 2, sm: 4 },
          backgroundColor: '#f8f9fa',
          borderRadius: 2
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          mb: 4 
        }}>
          <Box
            component="img"
            src={`/images/${productDetails.image}`}
            alt={productDetails.brandName}
            sx={{
              width: 'auto',
              height: '250px',
              objectFit: 'contain',
              mb: 3
            }}
          />
          <Typography 
            variant="h5" 
            sx={{ 
              color: '#2e7d32',
              fontWeight: 'bold',
              mb: 1
            }}
          >
            STATUS
          </Typography>
          <Chip 
            label="AUTHENTIC PRODUCT" 
            color="success" 
            sx={{ 
              fontWeight: 'bold',
              fontSize: '1.1rem',
              py: 1,
              px: 2
            }}
          />
        </Box>
        
        <Box sx={{ maxWidth: 600, mx: 'auto' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#1976d2',
                  fontWeight: 'bold',
                  mb: 1
                }}
              >
                Generic Name
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                {productDetails.genericName}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#1976d2',
                  fontWeight: 'bold',
                  mb: 1
                }}
              >
                Brand Name
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                {productDetails.brandName}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#1976d2',
                  fontWeight: 'bold',
                  mb: 1
                }}
              >
                Name and Address of Manufacturer
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.1rem', whiteSpace: 'pre-line' }}>
                AQEUS HEALTHCARE{'\n'}
                161, Daru Street, Vankal, Valsad, Gujarat - 396001
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#1976d2',
                  fontWeight: 'bold',
                  mb: 1
                }}
              >
                Batch No.
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                {productDetails.batchNumber}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#1976d2',
                  fontWeight: 'bold',
                  mb: 1
                }}
              >
                Manufacturing Date
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                {productDetails.mfgDate}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#1976d2',
                  fontWeight: 'bold',
                  mb: 1
                }}
              >
                Expiry Date
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                {productDetails.expiryDate}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#1976d2',
                  fontWeight: 'bold',
                  mb: 1
                }}
              >
                License No.
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                {productDetails.licenseNumber}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  );
} 